import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { getCurrentSlice } from 'utils';

/**
 * فیلتر انتخاب نوع محتوا
 */
export const MediaTypeFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, parentPlatform, className } = props;
  const filterOption = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds, platform } = filterOption;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const mediaTypeList = [
    {
      title: t('common:image'),
      id: platform === 'linkedin' ? 'image' : 'photo',
      testId: 'photo',
      isVisible: true,
    },
    { title: t('common:video'), id: 'video', testId: 'video', isVisible: true },
    {
      title: t('common:text'),
      id: 'text',
      testId: 'text',
      isVisible: !!(platform !== 'instagram' && platform !== 'telegram'),
    },
    {
      title: t('common:slide'),
      id: 'slide',
      testId: 'slide',
      isVisible: platform === 'instagram',
    },
    {
      title: t('filter:others'),
      id: 'other',
      testId: 'other',
      isVisible: platform === 'linkedin',
    },
  ];

  /**
   * انتخاب نوع محتوا
   */
  const handleChangeMediaType = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <div className={classNames('grid mb-12', className)}>
      {mediaTypeList?.map(({ id, title, testId, isVisible }) => {
        if (!isVisible) return null;

        return (
          <UiFormControlLabel
            key={id}
            className='mr-0'
            label={title}
            data-testid={`filter-media-type-${testId}-label`}
            control={
              <UiCheckbox
                name={id}
                checked={selectedIds?.includes(id)}
                onChange={(event) => handleChangeMediaType(event, id)}
                inputProps={{
                  'data-testid': `filter-media-type-${testId}-checkbox`,
                }}
                disabled={filterOption?.isDisabled}
              />
            }
          />
        );
      })}
    </div>
  );
};

MediaTypeFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
